import { useRecoilCallback, useRecoilValue, useSetRecoilState } from "recoil";
import {
  coPiAlertState,
  coPiListCheckedState,
  coPiListDataState,
  coPiListLoadFailedState,
  coPiSourceCheckedState,
  getCoPiList,
  makeAlertData
} from "../../store/CopilotListState";
import { userState } from "../../store/UserState";
import { useInterval } from "../../hooks/useInterval";
import { isEqualObject } from "../../utils/FPEUtils";

const CoPiListObserver = () => {
  const userGroup = useRecoilValue(userState).group;
  const setCoPiListData = useSetRecoilState(coPiListDataState);
  const setCoPiListChecked = useSetRecoilState(coPiListCheckedState);
  const setCoPiAlert = useSetRecoilState(coPiAlertState);
  const setCoPiSourceChecked = useSetRecoilState(coPiSourceCheckedState);
  const setCoPiListLoadFailed = useSetRecoilState(coPiListLoadFailedState);

  const observe = useRecoilCallback(({snapshot}) => async () => {
    const release = snapshot.retain();
    try {
      const prev = snapshot.getLoadable(coPiListDataState);
      let prevData;
      let newData;
      if (prev.state === 'loading') {
        prevData = null;
        newData = await prev.contents;
      } else {
        prevData = prev.contents;
        newData = await getCoPiList(userGroup);
        setCoPiListLoadFailed(false);
      }

      const coPiListChecked = await snapshot.getPromise(coPiListCheckedState);

      //差分があるか判定
      if (!isEqualObject(prevData, newData) || coPiListChecked === null) {
        setCoPiListData(newData);

        // チェック状態
        setCoPiListChecked(prev => {
          return newData?.map(data => {
            const code = data.aircraft_code;
            let checked = true;
            const selectData = prev?.find(d => d.aircraft_code === code);
            if (selectData) {
              checked = selectData.checked;
            }
            return {
              aircraft_code: code,
              checked: checked,
              icon_id: data.icon_id
            };
          });
        });

        setCoPiSourceChecked(prev => {
          const ret = {};
          newData?.forEach(data => {
            const checkedState = ret[data.aircraft_code] = {};
            const prevChecked = prev[data.aircraft_code];
            if (prevChecked) {
              data.sources.forEach(source => {
                const dataSourceId = source.data_source_id;
                if (prevChecked[dataSourceId] !== undefined) {
                  checkedState[dataSourceId] = prevChecked[dataSourceId];
                } else {
                  checkedState[dataSourceId] = true;
                }
              })
            } else {
              data.sources.forEach(source => {
                checkedState[source.data_source_id] = true;
              })
            }
          });
          return ret;
        });

        // Alert
        setCoPiAlert(prev => {
          return makeAlertData(newData, prev);
        });
      }
    } catch (e){
      setCoPiListLoadFailed(true);
      throw e;
    } finally {
      release();
    }
  }, []);

  useInterval(observe, 30000, true);

  return null;
}

export default CoPiListObserver;
